import {IntlShape} from 'react-intl';
import {getCachedMessage} from '../../../translations/TranslationCache';

/**
 * Minutes as `2h 5m` / `45m` / `2h`. Past 99 hours the minutes are dropped (rounded into the hours)
 * unless `ignoreMinuteTruncation`; with `appendHoursUnit` false it returns the bare hour count.
 *
 * Lives on its own so a module can format hours without importing `Util`, whose import graph pulls in
 * styled components that read design-system tokens at load time. `Util.convertMinutesToFullHour`
 * delegates here.
 */
export function convertMinutesToFullHour(
	minutes = 0,
	intl: IntlShape,
	ignoreMinuteTruncation?: boolean,
	appendHoursUnit = true
): string | number {
	const absoluteMinutes = Math.abs(Math.round(minutes));
	const fullHours = absoluteMinutes / 60;
	let justHours = Math.trunc(fullHours);
	const justMinutes = absoluteMinutes - justHours * 60;
	const hideMinutes = justMinutes > 0 && justHours > 99 && !ignoreMinuteTruncation;

	if (hideMinutes && justMinutes > 29) {
		justHours++;
	}

	if (!appendHoursUnit) {
		return justHours;
	}

	let formatted = minutes < 0 ? '-' : '';

	if (justHours > 0 && justMinutes > 0 && !hideMinutes) {
		formatted +=
			justHours +
			getCachedMessage(intl, 'common.hours.short') +
			' ' +
			justMinutes +
			getCachedMessage(intl, 'common.minutes.short');
	} else if (justMinutes > 0 && !hideMinutes) {
		formatted += justMinutes + getCachedMessage(intl, 'common.minutes.short');
	} else {
		formatted += justHours + getCachedMessage(intl, 'common.hours.short');
	}

	return formatted;
}
